<template>
  <div data-module="nav-spacer-header">
    <div class="spacer-layout" />
  </div>
</template>


<script>
/*
  Nav Spacer Header module
*/
export default {

  name: 'nav-spacer-header',

  props: ['data'],

};
</script>

<style lang="scss">
@import '~@/styles/_mixins.scss';

$works-header-overlay: 62px;

[data-module="nav-spacer-header"] {
  width: 100%;

  // media query props
  margin-top: rem($height--nav-bar-mobile * 1px); // adjust for nav bar
  margin-bottom: rem($layout--default-module-spacing-mobile);

  @include ngMq($nbp--tablet, up) {
    margin-top: rem($height--nav-bar-tablet * 1px);
    margin-bottom: rem($layout--default-module-spacing-tablet);
  }

  @include ngMq($nbp--desktop, up) {
    margin-top: rem($height--nav-bar-desktop * 1px);
    margin-bottom: rem($layout--default-module-spacing-desktop);
  }

  .spacer-layout {

    // media query props
    height: rem(0px);

    @include ngMq($nbp--tablet, up) {
      height: rem(10px);
    }
    @include ngMq($nbp--desktop, up) {
      height: rem(10px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/header/NavSpacer.vue